<template>
  <div id="PointsShopping">
    <div class="header flex-between">
      <div class="header-text">
        <h1>积分商城兑换查询-查看</h1>
      </div>
      <div class="header-button">
        <el-button class="iconfont icon-fanhui" @click="backHistory"
          >返回</el-button
        >
      </div>
    </div>

    <div class="biaoti">
      <span>兑换信息</span>
    </div>
    <div>
      <el-card>
        <!-- 表单 -->
        <div>
          <el-form label-width="150px" size="small">
            <el-row>
              <el-col :span="9">
                <el-form-item label="兑换记录编号">
                  <el-input
                    v-model="exchange.redemptionNo"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="领取方式">
                  <el-select
                    v-model="exchange.collectMethod"
                    style="width: 100%"
                    :disabled="true"
                  >
                    <el-option
                      v-for="item in collectMe"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="会员" class="boxcss">
                  <el-input
                    v-model="exchange.custName"
                    readonly
                    @click.native="Jumpmember"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="状态">
                  <el-select
                    v-model="exchange.state"
                    style="width: 100%"
                    :disabled="true"
                  >
                    <el-option
                      v-for="item in StateArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="会员卡号">
                  <el-input
                    v-model="exchange.CardNo"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="兑换数量">
                  <el-input v-model="exchange.qty" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="兑换日期">
                  <!-- <el-input></el-input> -->
                  <el-date-picker
                    v-model="exchange.redemptionTime"
                    type="date"
                    placeholder=""
                    :disabled="true"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="兑换总积分">
                  <el-input
                    v-model="exchange.exchangeSumPoint"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="领取门店">
                  <el-input
                    v-model="exchange.getShopCode"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="biaoti">
      <span>商品信息</span>
    </div>
    <div>
      <el-card>
        <!-- 表单 -->
        <div>
          <el-form label-width="150px" size="small">
            <el-row>
              <el-col :span="9">
                <el-form-item label="商品名称" class="boxcss">
                  <el-input
                    v-model="exchange.commodityName"
                    readonly
                    @click.native="commoditybtn"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="商品类型">
                  <el-select
                    v-model="exchange.commKind"
                    style="width: 100%"
                    :disabled="true"
                  >
                    <el-option
                      v-for="item in commKindArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="兑换的礼品SKU">
                  <el-input
                    v-model="exchange.GiftSKU"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="商品积分">
                  <el-input
                    v-model="exchange.CreditPoint"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="颜色">
                  <el-input
                    v-model="exchange.ColorAttrName"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9"> </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="尺码">
                  <el-input v-model="exchange.Size" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9"> </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="biaoti">
      <span>领取信息</span>
    </div>
    <div>
      <el-card>
        <!-- 表单 -->
        <div>
          <el-form label-width="150px" size="small">
            <el-row>
              <el-col :span="9">
                <el-form-item label="POS领取单号">
                  <el-input
                    v-model="exchange.getNo"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="领取时间">
                  <el-time-select
                    v-model="exchange.getTime"
                    :disabled="true"
                    placeholder=""
                    style="width: 100%"
                  >
                  </el-time-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="收货人姓名">
                  <el-input
                    v-model="exchange.receiver"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="收货手机号">
                  <el-input
                    v-model="exchange.recvPhone"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="收货地址">
                  <el-input
                    v-model="exchange.recvAddr"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="物流公司">
                  <el-input
                    v-model="exchange.expressCompany"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="物流单号">
                  <el-input
                    v-model="exchange.expressNo"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="发货时间">
                  <!-- <el-input></el-input> -->
                  <el-time-select
                    v-model="exchange.postTime"
                    :disabled="true"
                    placeholder=""
                    style="width: 100%"
                  >
                  </el-time-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="兑换核销提醒方式">
                  <el-radio-group
                    v-model="exchange.PubVeriCoupMode"
                    :disabled="true"
                  >
                    <el-radio :label="0">不提醒</el-radio>
                    <el-radio :label="1">公众号模板消息</el-radio>
                    <el-radio :label="2">短信消息</el-radio>
                    <el-radio :label="3">公众号模板消息和短信消息</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18">
                <el-form-item label="兑换到期提醒方式">
                  <el-radio-group
                    v-model="exchange.ExpirationMode"
                    :disabled="true"
                  >
                    <el-radio :label="0">不提醒</el-radio>
                    <el-radio :label="1">公众号模板消息</el-radio>
                    <el-radio :label="2">短信消息</el-radio>
                    <el-radio :label="3">公众号模板消息和短信消息</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="提前">
                  <el-input
                    style="width: 140px"
                    v-model="exchange.ExpirationTime"
                    :disabled="true"
                  ></el-input>
                  &nbsp; 天
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="biaoti">
      <span>券清单</span>
    </div>
    <div>
      <el-card>
        <!-- 表单 -->
        <div>
          <el-form label-width="150px" size="small">
            <el-row>
              <el-col :span="12">
                <el-form-item label="">
                  <el-table
                    size="mini"
                    class="table-style"
                    border
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                    }"
                    :cell-style="{ 'text-align': 'center' }"
                    ref="multipleTable"
                    :data="Securitieslist"
                    tooltip-effect="dark"
                  >
                    <el-table-column label width="35" type="index">
                    </el-table-column>
                    <el-table-column prop="coupCode" label="券编号">
                    </el-table-column>
                    <el-table-column prop="startDate" label="生效起始日期">
                      <template slot-scope="scope">
                        {{ scope.row.startDate | dateFormats }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="endDate" label="生效结束日期">
                      <template slot-scope="scope">
                        {{ scope.row.endDate | dateFormats }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="state" label="状态">
                      <template slot-scope="scope">
                        {{
                          scope.row.state === 0
                            ? "有效"
                            : "" || scope.row.state === 1
                            ? "已核销"
                            : "" || scope.row.state === 2
                            ? "已禁用"
                            : "" || scope.row.state === 3
                            ? "未发放"
                            : "" || scope.row.state === 4
                            ? "无效"
                            : ""
                        }}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="biaoti">
      <span>其他信息</span>
    </div>
    <div>
      <el-card>
        <!-- 表单 -->
        <div>
          <el-form label-width="150px" size="small">
            <el-row>
              <el-col :span="9">
                <el-form-item label="创建时间">
                  <el-time-picker
                    v-model="exchange.CreateTime"
                    :disabled="true"
                    style="width: 100%"
                    format="yyyy-mm-dd:hh:mm"
                  >
                  </el-time-picker>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="修改时间">
                  <el-time-picker
                    v-model="exchange.UpdateTime"
                    :disabled="true"
                    style="width: 100%"
                    format="yyyy-mm-dd:hh:mm"
                  >
                  </el-time-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { wastebtnquerychak, toviewuserApi } from "@/api/Integralquery";
export default {
  name: "PointsShopping",

  data() {
    return {
      value: "",
      form: {
        radio: "所有商品",
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "按类别",
        desc: "",
      },
      ruleForm: {
        radio: "",
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
      //兑换信息接口数据
      exchange: [],
      //劵清单
      Securitieslist: [],
      //状态
      StateArr: [
        {
          value: 0,
          label: "未领取",
        },
        {
          value: 1,
          label: "已领",
        },
        {
          value: 2,
          label: "废弃",
        },
      ],
      //领取方式
      collectMe: [
        {
          value: 1,
          label: "到店自取",
        },
        {
          value: 2,
          label: "快递邮寄",
        },
      ],
      //商品类型
      commKindArr: [
        {
          value: 0,
          label: "礼券",
        },
        {
          value: 1,
          label: "礼物",
        },
        {
          value: 2,
          label: "券包",
        },
      ],
    };
  },
  created() {
    this.commRedemption();
  },
  methods: {
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    // 点击返回按钮  返回上一页面
    backHistory() {
      this.$router.go(-1); //返回上一层
    },
    async commRedemption() {
      let userName = "";
      if (
        this.$route.query.restion === undefined ||
        this.$route.query.restion === ""
      ) {
        userName = this.$route.query.id;
      } else {
        userName = this.$route.query.restion;
      }
      await wastebtnquerychak({ redemptionID: userName }).then((res) => {
        if (res.message == "success") {
          this.exchange = res;
          //劵清单数据存放
          this.Securitieslist = res.couponList;
          // console.log(this.Securitieslist);
        }
      });
    },
    async Jumpmember() {
      await toviewuserApi({ custID: this.exchange.CustID }).then((res) => {
        if (res.message == "success") {
          this.$router.push({
            path: "/LookMember",
            query: {
              custID: this.exchange.CustID,
              showButton: this.exchange.showButtons,
            },
          });
        }
      });
    },
    //商品名称跳转
    commoditybtn() {
      // console.log(this.exchange.commodityID);
      if (this.exchange.commKind === 0) {
        this.$router.push({
          path: "/ViewGift",
          query: {
            Info: this.exchange.commodityID,
          },
        });
      }
      if (this.exchange.commKind === 1) {
        // console.log('礼物');
        this.$router.push({
          path: "/GiftSee",
          query: {
            come: this.exchange.commodityID,
          },
        });
      }
      if (this.exchange.commKind === 2) {
        // console.log('券包');
        this.$router.push({
          path: "/VoucherView",
          query: {
            Juan: this.exchange.commodityID,
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#PointsShopping {
  height: 1600px;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.biaoti {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  padding-left: 20px;
  background-color: #e3e3e3;
}
// input框的圆角取消
/deep/input {
  border-radius: 0 !important;
}
::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  .boxcss input {
    text-decoration: underline;
    color: blue;
  }
}
</style>
